import { schema } from "normalizr";

const linkItems = new schema.Entity("LinkItems");

const linkList = new schema.Entity("linkLists", { LinkItems: [linkItems] });

export const linkListList = new schema.Array(linkList);
